// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","sortableList":"_1cqzIhd91fOTlpBl2_hfUv","disabled":"_2CmZzM85iUXGUG3i9G0KxR"};